import axios from "axios";

// CORRECTION : utiliser la variable d'environnement au lieu de l'URL hardcodée
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
});

// Ajouter le token automatiquement à chaque requête
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("marinadz_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ─── Interceptor ZTAA ────────────────────────────────────────────────────────
let challengeEnCours = false;

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const data = error.response?.data;

    if (
      error.response?.status === 401 &&
      data?.error === "passkey_challenge_required" &&
      !challengeEnCours
    ) {
      challengeEnCours = true;
      try {
        const ok = await window.ztaa?.handleChallenge?.();
        if (ok) {
          const newToken = localStorage.getItem("marinadz_token");
          error.config.headers.Authorization = `Bearer ${newToken}`;
          error.config._retry = true;
          return API(error.config);
        } else {
          localStorage.removeItem("marinadz_token");
          window.location.href = "/connexion";
        }
      } catch (e) {
        console.error("[ZTAA] Erreur challenge :", e);
      } finally {
        challengeEnCours = false;
      }
    }

    if (
      error.response?.status === 403 &&
      data?.error === "session_suspended"
    ) {
      localStorage.removeItem("marinadz_token");
      alert("⚠️ Activité inhabituelle détectée. Vous avez été déconnecté.");
      window.location.href = "/connexion";
    }

    return Promise.reject(error);
  }
);

// ─── AUTH ────────────────────────────────────────────────────────────────────
export const register        = (data) => API.post("/auth/register", data);
export const login           = (data) => API.post("/auth/login", data);
export const googleLogin     = (data) => API.post("/auth/google", data);
export const getMe           = ()     => API.get(`/auth/me?_=${Date.now()}`);
export const updateProfile   = (data) => API.put("/auth/update", data);
export const upgradeExposant = (data) => API.post("/auth/upgrade-exposant", data);
export const requestPasswordReset = (data) => API.post("/auth/reset-password/request", data);
export const confirmPasswordReset  = (data) => API.post("/auth/reset-password/confirm", data);

// ─── ANNONCES ────────────────────────────────────────────────────────────────
export const getAnnonces     = (params)   => API.get("/annonces", { params });
export const getAnnonce      = (id)       => API.get(`/annonces/${id}`);
export const getMesAnnonces  = ()         => API.get("/annonces/mes-annonces");
export const createAnnonce   = (data)     => API.post("/annonces", data);
export const updateAnnonce   = (id, data) => API.put(`/annonces/${id}`, data);
export const deleteAnnonce   = (id)       => API.delete(`/annonces/${id}`);
export const accepterAnnonce = (id)       => API.put(`/annonces/${id}/accepter`);
export const refuserAnnonce  = (id, data) => API.put(`/annonces/${id}/refuser`, data);
export const toggleStatut    = (id)       => API.put(`/annonces/${id}/statut`);

// ─── DOCUMENTS ───────────────────────────────────────────────────────────────
export const getAnnonceDocuments = (annonceId) => API.get(`/annonces/${annonceId}/documents`);

// ─── PAIEMENTS ───────────────────────────────────────────────────────────────
export const soumettrePaiement = (data)       => API.post("/paiements", data);
export const getMesPaiements   = ()           => API.get("/paiements/mes-paiements");
export const getAllPaiements    = ()           => API.get("/paiements");
export const confirmerPaiement = (id)         => API.put(`/paiements/${id}/confirmer`);
export const refuserPaiement   = (id, data)   => API.put(`/paiements/${id}/refuser`, data);

// ─── NOTIFICATIONS ───────────────────────────────────────────────────────────
export const getNotifications = ()   => API.get("/notifications");
export const marquerToutLu    = ()   => API.put("/notifications/lire-tout");
export const marquerLu        = (id) => API.put(`/notifications/${id}/lire`);

// ─── FAVORIS ─────────────────────────────────────────────────────────────────
export const getFavoris   = ()   => API.get("/favoris");
export const toggleFavori = (id) => API.post(`/favoris/${id}`);

// ─── MESSAGES ────────────────────────────────────────────────────────────────
export const getConversations = ()       => API.get("/messages");
export const getMessages      = (convId) => API.get(`/messages/${convId}`);
export const sendMessage      = (data)   => API.post("/messages", data);

// ─── RFQ ─────────────────────────────────────────────────────────────────────
export const createRFQ      = (data)  => API.post("/rfq", data);
export const getAllRFQ       = ()      => API.get("/rfq");
export const getMesRFQ       = ()      => API.get("/rfq/mes-rfq");
export const repondreRFQ     = (data)  => API.post("/rfq/repondre", data);
export const getReponsesRFQ  = (rfqId) => API.get(`/rfq/${rfqId}/reponses`);

// ─── ABONNEMENT ──────────────────────────────────────────────────────────────
export const getMonAbonnement    = ()          => API.get("/abonnement/mon-abonnement");
export const soumettreAbonnement  = (data)     => API.post("/abonnement", data);
export const getAllAbonnements   = ()          => API.get("/abonnement");
export const accepterAbonnement  = (id)        => API.put(`/abonnement/${id}/accepter`);
export const rejeterAbonnement   = (id, data)  => API.put(`/abonnement/${id}/rejeter`, data);

// ─── CONTACT ─────────────────────────────────────────────────────────────────
export const sendContact         = (data)      => API.post("/contact", data);
export const getContactMessages  = ()          => API.get("/contact");
export const repondreContact     = (id, data)  => API.post(`/contact/${id}/repondre`, data);

// ─── ADMIN ───────────────────────────────────────────────────────────────────
export const getStats       = ()                 => API.get("/admin/stats");
export const getUsers       = (params = {})      => API.get("/admin/users", { params });
export const deleteUser     = (id)               => API.delete(`/admin/users/${id}`);
export const updateRole     = (id, data)         => API.put(`/admin/users/${id}/role`, data);
export const getAllAnnonces  = (params = {})      => API.get("/admin/annonces", { params });
export const getStatsExposant = (id)             => API.get(`/admin/stats-exposant/${id}`);

// ─── UPLOAD ──────────────────────────────────────────────────────────────────
export const uploadFiles = (formData) => API.post("/upload", formData, {
  headers: { "Content-Type": "multipart/form-data" },
});
export const uploadDocs = (formData) => API.post("/upload-docs", formData, {
  headers: { "Content-Type": "multipart/form-data" },
});

// ─── EXPOSANTS ───────────────────────────────────────────────────────────────
export const getExposants = () => API.get("/exposants");

// ─── RATINGS / SCORES ────────────────────────────────────────────────────────
export const getRatings    = (exposantId)       => API.get(`/ratings/${exposantId}`);
export const submitRating  = (exposantId, data) => API.post(`/ratings/${exposantId}`, data);

// ─── IA ──────────────────────────────────────────────────────────────────────
export const aiEnhanceAnnonce   = (data) => API.post("/ai/enhance-annonce", data);
export const aiSearchAssist     = (q)    => API.get(`/ai/search-assist?q=${encodeURIComponent(q)}`);
export const aiGenerateMinisite = ()     => API.post("/ai/generate-minisite");
export const aiClassifyExposant = ()     => API.post("/ai/classify-exposant");
export const aiGetMinisite      = (id)   => API.get(`/ai/minisite/${id}`);

// ─── IMPORT SITE WEB IA ──────────────────────────────────────────────────────
export const websiteImportAnalyze  = (data) => API.post("/website-import/analyze", data);
export const websiteImportConfirm  = (data) => API.post("/website-import/confirm", data);
export const websiteImportHistory  = ()     => API.get("/website-import/history");

export default API;